import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.css";
import Styles from "./Styles";
import { getDefaultProps } from "../../api/client";
import "./PopDeviceStatus.css";
import NoImage from "./../../assets/images/no_image.png";
import moment from "moment";

function PopDeviceStatus(props) {
  const [swiperIdx, setSwiperIdx] = useState(0);
  let iData = [];
  let serialNo = "",
    updateDt = "";

  if (props != null && props.mediaData != null && props.mediaData.length > 0) {
    /*
          미디어 타입 별 출력
          i > image
          v > video
        */
    iData = props.mediaData.filter((iItem) => iItem.mediaTp === "i");
    serialNo = props.mediaData[swiperIdx].serialNo;
    updateDt = props.mediaData[0].updateDt ? moment(props.mediaData[0].updateDt).format("YYYY-MM-DD HH:mm:ss") : "";
  }

  const handleImgError = (e) => {
    e.target.src = NoImage;
  };

  useEffect(() => {}, []);

  SwiperCore.use([Navigation, Pagination, Autoplay]);
  return (
    <Styles>
      <div style={{ display: "flex", height: "30px" }}>
        <p style={{ marginRight: "auto" }}>디바이스 ID</p>
        <p style={{ marginLeft: "auto" }}>{serialNo}</p>
      </div>
      <div style={{ display: "flex", height: "30px" }}>
        <p style={{ marginRight: "auto" }}>최종 사진촬영 일시</p>
        <p style={{ marginLeft: "auto" }}>{updateDt}</p>
      </div>
      <div className={"status-container"}>
        <Swiper
          className='banner'
          direction='horizontal'
          spaceBetween={0}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          loop={false}
          observer='true'
          observeParents={true}
          onSlideChange={(swiper) => setSwiperIdx(swiper.realIndex)}
        >
          {iData.map((values, index) => (
            <SwiperSlide key={index}>
              <img
                src={getDefaultProps("fileUrl") + iData[index].fileNm}
                alt={iData[index].fileNm}
                onError={handleImgError}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Styles>
  );
}

export default PopDeviceStatus;
